import { render, staticRenderFns } from "./recordChanges.vue?vue&type=template&id=6256b999&scoped=true"
import script from "./recordChanges.vue?vue&type=script&lang=js"
export * from "./recordChanges.vue?vue&type=script&lang=js"
import style0 from "./recordChanges.vue?vue&type=style&index=0&id=6256b999&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6256b999",
  null
  
)

export default component.exports